import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  productInfo: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 15,
    marginTop: 15,
    backgroundColor: '#FFFFFF',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,

    elevation: 5,
    borderRadius: 10,
  },
  productInfoColumn: {
    flex: 1,
    flexDirection: 'column',
  },
  nameColumn: {
    flex: 2,
    paddingLeft: 10,
    paddingTop: 5,
  },
  productImage: {
    marginTop: 6,
    width: 100,
    height: 100,
    borderRadius: 10,
    alignSelf: 'center',
  },
  button: {
    minWidth: 50,
    maxWidth: 100,
    height: 32,
    borderRadius: 15,
    padding: 10,
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  buttonText: {
    color: '#FFF',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: 13,
  },
});
